import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomImage from "../../../common/components/image/CustomImage";
import { C2Text, C3Text, C4Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import styled from "styled-components";
import UIUtil from "../../../common/utils/UIUtil";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";

const StyledWrapper = styled.div`
    position: absolute;
    top: ${({ top }) => top ?? "100%"};
    left: ${({ $openedLeftSide }) => ($openedLeftSide ? "-195px" : "0px")};
    z-index: 1000;
    margin-top: 8px;
    width: 232px;
    background-color: ${Theme.color.white_07};
    border-radius: 12px;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    box-shadow: 0 4px 16px ${Theme.color.black_01};
    padding: 0;
    box-sizing: border-box;
`;

function DeviceHoverCard({ device, openedLeftSide = true, ...props }) {
    const { statusTextColor, statusBackgroundColor, statusIcon, statusText } = UIUtil.getDeviceStatusUI(device.status);

    return (
        <StyledWrapper $openedLeftSide={openedLeftSide} top={props.top}>
            <Row justifyContent={"space-between"} width={"100%"} padding={"18px 16px 16px 24px"}>
                <Row>
                    <CustomImage imageName={`image_${device.type}`} width={"29px"} height={"36px"} />
                    <SizedBox width={"14px"} />
                    <Column justifyContent={"flex-start"} alignItem={"flex-start"}>
                        <C4Text>{Translate(`common.${device.type}`)}</C4Text>
                        <SizedBox height={"4px"} />
                        <C3Text fontWeight={"500"} fontColor={Theme.color.black}>
                            {device.name}
                        </C3Text>
                    </Column>
                </Row>
                <SizedBox
                    width={"auto"}
                    height={"auto"}
                    padding={"5px 4px"}
                    borderRadius={"6px"}
                    backgroundColor={statusBackgroundColor}
                >
                    <Row>
                        <CustomIcon iconName={statusIcon} size={"18px"} />
                        <SizedBox width={"4px"} />
                        <C2Text fontColor={statusTextColor}>{statusText}</C2Text>
                    </Row>
                </SizedBox>
            </Row>
        </StyledWrapper>
    );
}

export default DeviceHoverCard;
